import {
  FieldError,
  UseFormSetValue,
  UseFormTrigger,
  UseFormWatch,
} from 'react-hook-form'
import { DateTimePickerField } from 'utoniq-ui'

import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'
import { convertDatePickerValueToDate, dayjs } from '@/lib/dayjs'

import { CreateEventValue } from '../EventCreateForm'

type EventPublishDateCellProps = {
  watch: UseFormWatch<CreateEventValue>
  setValue: UseFormSetValue<CreateEventValue>
  errors: FieldError[]
  trigger: UseFormTrigger<CreateEventValue>
}
export const EventPublishDateCell: Cell<EventPublishDateCellProps> = ({
  watch,
  setValue,
  errors,
  trigger,
}) => {
  const { t } = useTranslation('consoleEventCreate')
  return (
    <>
      <CellFrame sx={{ pb: 3 }}>
        <DateTimePickerField
          onChange={date => {
            setValue(
              'publishStartedAt',
              convertDatePickerValueToDate(date) as never,
              {
                shouldValidate: true,
                shouldDirty: true,
              }
            )
            trigger('publishEndedAt')
          }}
          value={
            watch('publishStartedAt') ? dayjs(watch('publishStartedAt')) : null
          }
          placeholder={t('publishStartAtPlaceholder')}
          error={errors[0]}
          title={t('publishStartAtLabel')}
          titleProps={{ variant: 'subtitle1', color: 'text.primary' }}
        />
        <DateTimePickerField
          onChange={date => {
            setValue(
              'publishEndedAt',
              convertDatePickerValueToDate(date) as never,
              {
                shouldValidate: true,
                shouldDirty: true,
              }
            )
          }}
          value={
            watch('publishEndedAt') ? dayjs(watch('publishEndedAt')) : null
          }
          placeholder={t('publishEndAtPlaceholder')}
          error={errors[1]}
          title={t('publishEndAtLabel')}
          titleProps={{ variant: 'subtitle1', color: 'text.primary' }}
        />
      </CellFrame>
    </>
  )
}
